import React, { useEffect, useMemo, useState } from 'react';
import useLabFilters from './useLabFilters';
import { ZipDeviceControlUnit } from '../../../../../../redux/controlUnit/controlUnit.model';
import { CommanderMonitoringFilterLogicalObject } from '../../../../../../redux/monitoring/api/util/filter/filter.model';
import { setWith } from 'lodash';

function useLabStateFilters(zipDevicesControlUnits: ZipDeviceControlUnit[]) {
  const { data: labFiltersFeatures } = useLabFilters();
  const defaultConnectionFilterLogicalObject = useMemo(
    () =>
      getConnectionFilterLogicalObjectFromZipDeviceControlUnits(
        zipDevicesControlUnits,
        true
      ),
    [zipDevicesControlUnits, labFiltersFeatures]
  );
  const [connectionDigitalFilterObject, setConnectionDigitalFilterObject] =
    useState<CommanderMonitoringFilterLogicalObject>(
      defaultConnectionFilterLogicalObject
    );
  const viewModeControls = useState<'default' | 'table'>('default');

  const defaultCloudGeneratedFilterLogicalObject = useMemo(
    () =>
      getCloudGeneratedFilterLogicalObjectFromZipDeviceControlUnits(
        zipDevicesControlUnits,
        true
      ),
    [zipDevicesControlUnits, labFiltersFeatures]
  );
  const [
    cloudGeneratedFilterLogicalObject,
    setCloudGeneratedFilterLogicalObject,
  ] = useState<CommanderMonitoringFilterLogicalObject>(
    defaultCloudGeneratedFilterLogicalObject
  );
  useEffect(() => {
    setConnectionDigitalFilterObject(defaultConnectionFilterLogicalObject);
    setCloudGeneratedFilterLogicalObject(
      defaultCloudGeneratedFilterLogicalObject
    );
  }, [zipDevicesControlUnits]);

  return {
    connectionDigitalFilterControls: [
      connectionDigitalFilterObject,
      setConnectionDigitalFilterObject,
    ],
    cloudGeneratedFilterControls: [
      cloudGeneratedFilterLogicalObject,
      setCloudGeneratedFilterLogicalObject,
    ],
    viewModeControls,
    labFiltersFeatures,
  } as const;
}

export default useLabStateFilters;

export const CHANNELS_CONNECTIONS_SUPPORTED = [
  'mqttConnection',
  'brokerConnection',
  'vpnConnection',
];
export const CONNECTION_INFO_CU_KEY = 'device';

export const CHANNELS_ANALOG_CLOUD_GENERATED = [
  'cloud_generated_mqttBandwidthIn',
  'cloud_generated_mqttBandwidthOut',
  'cloud_generated_mqttConnectedSince',
  'cloud_generated_vpnBandwidthIn',
  'cloud_generated_vpnBandwidthOut',
  'cloud_generated_vpnConnectedSince',
];
export const CLOUD_GENERATED_CU_KEY = '1002';

export function getConnectionFilterLogicalObjectFromZipDeviceControlUnits(
  zipDevicesControlUnits: ZipDeviceControlUnit[],
  fillWith = false
) {
  const dictionary: CommanderMonitoringFilterLogicalObject = {};
  zipDevicesControlUnits.forEach((zipDeviceControlUnit) => {
    CHANNELS_CONNECTIONS_SUPPORTED?.forEach((eventId) => {
      setWith(
        dictionary,
        [zipDeviceControlUnit.deviceId, CONNECTION_INFO_CU_KEY, eventId],
        fillWith,
        Object
      );
    });
  });
  return dictionary;
}

export function getCloudGeneratedFilterLogicalObjectFromZipDeviceControlUnits(
  zipDevicesControlUnits: ZipDeviceControlUnit[],
  fillWith = false
) {
  const dictionary: CommanderMonitoringFilterLogicalObject = {};
  zipDevicesControlUnits.forEach((zipDeviceControlUnit) => {
    CHANNELS_ANALOG_CLOUD_GENERATED?.forEach((eventId) => {
      setWith(
        dictionary,
        [zipDeviceControlUnit.deviceId, CLOUD_GENERATED_CU_KEY, eventId],
        fillWith,
        Object
      );
    });
  });
  return dictionary;
}
